import { render, staticRenderFns } from "./Video1.vue?vue&type=template&id=0cc7f436&scoped=true"
import script from "./Video1.vue?vue&type=script&lang=js"
export * from "./Video1.vue?vue&type=script&lang=js"
import style0 from "./Video1.vue?vue&type=style&index=0&id=0cc7f436&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cc7f436",
  null
  
)

export default component.exports